export const GET_SER_DEVICE_LIST_REQUEST = 'GET_SER_DEVICE_LIST_REQUEST';
export const GET_SER_DEVICE_LIST_SUCCESS = 'GET_SER_DEVICE_LIST_SUCCESS';
export const GET_SER_DEVICE_LIST_ERROR = 'GET_SER_DEVICE_LIST_ERROR';

export const CHECK_STOCK_AVAILABILITY_REQUEST = 'CHECK_STOCK_AVAILABILITY_REQUEST';
export const CHECK_STOCK_AVAILABILITY_SUCCESS = 'CHECK_STOCK_AVAILABILITY_SUCCESS';
export const CHECK_STOCK_AVAILABILITY_ERROR = 'CHECK_STOCK_AVAILABILITY_ERROR';
